import { useState } from "react";
import "./testimonials.scss";
import Carousel from "react-grid-carousel";

const testimonialData = [
  {
    name: "David",
    summary:
      "David felt inspired and motivated by the speakers, leaving with clear next steps to grow his business.",
    src: "https://www.youtube.com/embed/oA0FPabCv2o?si=o4OOlkeI_dhLYqy-",
  },
  {
    name: "Satinder",
    summary:
      "Satinder found the event phenomenal, packed with insights and ideas she's excited to implement.",
    src: "https://www.youtube.com/embed/ygmwwNnMzlI?si=HW-5xHVmT3TyceP1",
  },
  {
    name: "Valerie",
    summary:
      "Valerie described the experience as life-changing with lasting impact on her business and direction.",
    src: "https://www.youtube.com/embed/xJHraCyT2is?si=eHdjgPbzTDIrObI9",
  },
  {
    name: "Steven",
    summary:
      "Steven appreciated the blend of wellness and strategy, gaining tools to succeed personally and professionally.",
    src: "https://www.youtube.com/embed/NpmrOb786MU?si=iU0NauUb4pBU4N3x",
  },
  {
    name: "Kerry",
    summary:
      "Kerry reconnected with her purpose and gained clarity beyond financial goals for her business journey.",
    src: "https://www.youtube.com/embed/WdrdolEXKkU?si=9lAv-lzKD0ZVRrK2",
  },
  {
    name: "Raghu",
    summary:
      "Raghu valued insights on branding and leadership, leaving energized and aligned with his growth path.",
    src: "https://www.youtube.com/embed/wJpYFxTnl9Y?si=Nc_ws4UV3hrU6tLM",
  },
];

export default function Testimonials() {
  return (
    <section className="carousel__main">
      <h2>This Is What It Feels Like to Be at SBC</h2>
      <Carousel
        cols={3}
        rows={1}
        gap={20}
        loop
        responsiveLayout={[
          {
            breakpoint: 1200,
            cols: 2,
            rows: 1,
            gap: 15,
          },
          {
            breakpoint: 900,
            cols: 1,
            rows: 1,
            gap: 15,
          },
        ]}
      >
        {testimonialData.map(({ name, summary, src }, idx) => (
          <Carousel.Item key={idx}>
            <article className="carousel__item">
              <div className="video-wrapper">
                <iframe
                  src={src}
                  title={`SBC ${name} Testimonial`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  referrerPolicy="strict-origin-when-cross-origin"
                ></iframe>
              </div>

              <p className="carousel--text">{summary}</p>
            </article>
          </Carousel.Item>
        ))}
      </Carousel>
    </section>
  );
}
